module.exports = __webpack_public_path__ + "img/pause.63d6737d.svg";